<div class="container-flex">
    <div class="row mx-0">
        <div class="position-fixed w-100 h-100" style="top:8px; left:48px; z-index:1602"
             *ngIf="isLoading || areFlagsLoading || areDispositionsLoading || submittingManualRecording || recordingsMainService.isUrlLoading || recordingsMainService.areFlagsLoading || recordingsMainService.isMonitoringDataLoading">
            <cv-loader size="large" [overlay]="true"></cv-loader>
        </div>

        <div class="col"></div>

        <div class="content col-6 px-5 py-4 my-4" style="min-width:686px" [hidden]="recordingsMainService.view != 0">
            <div class="mb-3 font-size-20" cvLocalizedText langSection="Recordings" langKey="Filter_Title">Filter and load to view recordings.</div>

            <!--Group Selectors-->
            <div class="mb-3">
                <cv-group-selector pageName="FindRecordingToMonitor" [baseGroupType]="0" [showSelectedToggle]="false" [hasMultiSelect]="true"
                                   [hasSelectedToggle]="false" [removeTopLevel]="false" direction="horizontal"></cv-group-selector>

                <cv-group-selector pageName="FindRecordingToMonitor" [baseGroupType]="1" [showSelectedToggle]="false" [hasMultiSelect]="true"
                                   [hasSelectedToggle]="false" [removeTopLevel]="false" direction="horizontal"></cv-group-selector>
            </div>

            <!--Date/Time Filters-->
            <div class="d-flex">
                <div>
                    <div class="mb-1" cvLocalizedText langSection="Controls" langKey="Date_Range">Date Range</div>
                    <cv-baremetrics-calendar class="d-block daterange daterange--double" [(startDate)]="recordingSettings.StartDate" [(endDate)]="recordingSettings.EndDate" placeholder="00/00/0000"
                                             [earliestDate]="sixMonthsAgo"></cv-baremetrics-calendar>

                    <div class="d-flex align-items-center color-redRyder" *ngIf="!recordingSettings.StartDate || !recordingSettings.EndDate || recordingSettings.StartDate > recordingSettings.EndDate">
                        <div><svg class="icon-12 fill-redRyder mr-1"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg></div>
                        <span cvLocalizedText langSection="Recordings" langKey="Invalid_Setting">Setting is Invalid</span>
                    </div>
                </div>

                <div class="ml-5">
                    <label class="mb-1" for="recFilterLengthMin" cvLocalizedText langSection="Recordings" langKey="Length_Min">Length (Min)</label>
                    <input type="text" class="form-control" style="width:100px" [(ngModel)]="recordingSettings.LengthMin" placeholder="00:00:00" id="recFilterLengthMin" />

                    <!--Using [class.invisible] allows the message to take up as much room as needed so that the Max input doesn't move when the message appears-->
                    <div class="d-flex align-items-center color-redRyder" [class.invisible]="validateTimeType(this.recordingSettings.LengthMin)">
                        <div><svg class="icon-12 fill-redRyder mr-1"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg></div>
                        <span cvLocalizedText langSection="Recordings" langKey="Invalid_Setting">Setting is Invalid</span>
                    </div>
                </div>

                <div class="ml-3">
                    <label class="mb-1" for="recFilterLengthMax" cvLocalizedText langSection="Recordings" langKey="Length_Max">Length (Max)</label>
                    <input type="text" class="form-control" style="width:100px" [(ngModel)]="recordingSettings.LengthMax" placeholder="00:00:00" id="recFilterLengthMax" />

                    <div class="d-flex align-items-center color-redRyder" [class.invisible]="validateTimeType(this.recordingSettings.LengthMax)">
                        <div><svg class="icon-12 fill-redRyder mr-1"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg></div>
                        <span cvLocalizedText langSection="Recordings" langKey="Invalid_Setting">Setting is Invalid</span>
                    </div>
                </div>
            </div>

            <!--Contact Radio Buttons-->
            <div class="d-flex">
                <div class="mr-4" style="width:125px">
                    <div cvLocalizedText langSection="Recordings" langKey="Call_Types">Call Types</div>

                    <div class="form-check mt-1">
                        <input class="form-check-input" type="radio" name="contactTypeRadio" [(ngModel)]="recordingSettings.ContactType" id="contactAllRadio" [value]="0" />
                        <label class="form-check-label pl-1 position-relative" style="left:-4px" for="contactAllRadio" cvLocalizedText langSection="Recordings" langKey="All">All</label>
                    </div>

                    <div class="form-check mt-1">
                        <input class="form-check-input" type="radio" name="contactTypeRadio" [(ngModel)]="recordingSettings.ContactType" id="contactAudioRadio" [value]="1" />
                        <label class="form-check-label pl-1 position-relative" style="left:-4px" for="contactAudioRadio" cvLocalizedText langSection="Recordings" langKey="Audio">Audio</label>
                    </div>

                    <div class="form-check mt-1">
                        <input class="form-check-input" type="radio" name="contactTypeRadio" [(ngModel)]="recordingSettings.ContactType" id="contactTextRadio" [value]="2" />
                        <label class="form-check-label pl-1 position-relative" style="left:-4px" for="contactTextRadio" cvLocalizedText langSection="Recordings" langKey="Text">Text</label>
                    </div>
                </div>

                <div>
                    <div cvLocalizedText langSection="Recordings" langKey="Call_Status">Call Status</div>

                    <div class="form-check mt-1">
                        <input class="form-check-input" type="radio" name="contactStatusRadio" [(ngModel)]="recordingSettings.ContactStatus" id="statusAllRadio" [value]="0" />
                        <label class="form-check-label pl-1 position-relative" style="left:-4px" for="statusAllRadio" cvLocalizedText langSection="Recordings" langKey="All">All</label>
                    </div>

                    <div class="form-check mt-1">
                        <input class="form-check-input" type="radio" name="contactStatusRadio" [(ngModel)]="recordingSettings.ContactStatus" id="statusMonitoredRadio" [value]="1" />
                        <label class="form-check-label pl-1 position-relative" style="left:-4px" for="statusMonitoredRadio" cvLocalizedText langSection="Recordings" langKey="Monitored">Monitored</label>
                    </div>

                    <div class="form-check mt-1">
                        <input class="form-check-input" type="radio" name="contactStatusRadio" [(ngModel)]="recordingSettings.ContactStatus" id="statusUnmonitoredRadio" [value]="2" />
                        <label class="form-check-label pl-1 position-relative" style="left:-4px" for="statusUnmonitoredRadio" cvLocalizedText langSection="Recordings" langKey="Unmonitored">Unmonitored</label>
                    </div>
                </div>
            </div>

            <!--Contact Text Fields-->
            <div class="d-flex mt-3">
                <div class="mr-3">
                    <label class="mb-1" for="recFilterContactID" cvLocalizedText langSection="Recordings" langKey="Contact_ID">Contact ID</label>
                    <input class="form-control" type="text" id="recFilterContactID" [(ngModel)]="recordingSettings.ContactId" />

                    <div class="d-flex align-items-center color-redRyder" [class.invisible]="valueWithinBigIntRange(recordingSettings.ContactId)">
                        <div><svg class="icon-12 fill-redRyder mr-1"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg></div>
                        <span cvLocalizedText langSection="Recordings" langKey="Invalid_Setting">Setting is Invalid</span>
                    </div>
                </div>

                <div class="mr-3">
                    <label class="mb-1" for="recFilterContactSource" cvLocalizedText langSection="Recordings" langKey="Contact_Source">Contact Source</label>
                    <input class="form-control" type="text" id="recFilterContactSource" [(ngModel)]="recordingSettings.ContactSource" />

                    <div class="d-flex align-items-center color-redRyder" [class.invisible]="!recordingsMainService.isNotANumber(recordingSettings.ContactSource)">
                        <div><svg class="icon-12 fill-redRyder mr-1"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg></div>
                        <span cvLocalizedText langSection="Recordings" langKey="Invalid_Setting">Setting is Invalid</span>
                    </div>
                </div>

                <div>
                    <label class="mb-1" for="recFilterOtherID" cvLocalizedText langSection="Recordings" langKey="Other_ID">Other ID</label>
                    <input class="form-control" type="text" id="recFilterOtherID" [(ngModel)]="recordingSettings.OtherId" />

                    <div class="d-flex align-items-center color-redRyder" [class.invisible]="!recordingsMainService.isNotANumber(recordingSettings.OtherId)">
                        <div><svg class="icon-12 fill-redRyder mr-1"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg></div>
                        <span cvLocalizedText langSection="Recordings" langKey="Invalid_Setting">Setting is Invalid</span>
                    </div>
                </div>
            </div>

            <!--Disposition/Flag Dropdowns-->
            <div class="d-flex">
                <div class="mr-3" style="width:250px">
                    <label class="mb-1" for="lstDisposition" cvLocalizedText langSection="Recordings" langKey="Disposition">Disposition</label>

                    <select class="form-control" [(ngModel)]="recordingSettings.SelectedDisposition">
                        <option [ngValue]="recordingsMainService.localization.get('No_Dispositions_Found')" disabled *ngIf="dispositions?.length == 0"
                                cvLocalizedText langSection="Recordings" langKey="No_Dispositions_Found">No Dispositions Found</option>
                        <option [label]="recordingsMainService.localization.get('All')" [ngValue]="recordingsMainService.localization.get('All')" *ngIf="dispositions?.length > 0"
                                cvLocalizedText langSection="Recordings" langKey="All">All</option>
                        <option *ngFor="let disposition of dispositions" [label]="disposition.DispositionName" [ngValue]="disposition.DispositionName">{{disposition.DispositionName}}</option>
                    </select>
                </div>

                <div style="width:250px">
                    <label class="mb-1" for="lstFlags" cvLocalizedText langSection="Recordings" langKey="Flag">Flag</label>

                    <select class="form-control" [(ngModel)]="recordingSettings.SelectedFlag">
                        <option [label]="recordingsMainService.localization.get('No_Flags_Created')" [ngValue]="-1" disabled *ngIf="recordingsMainService.flags?.length == 0"
                                cvLocalizedText langSection="Recordings" langKey="No_Flags_Created">No Flags Created</option>
                        <option [label]="recordingsMainService.localization.get('All')" [ngValue]="0" *ngIf="recordingsMainService.flags?.length > 0"
                                cvLocalizedText langSection="Recordings" langKey="All">All</option>
                        <option *ngFor="let flag of recordingsMainService.flags" [label]="flag.RecordingFlagName" [ngValue]="flag.RecordingFlagID">{{flag.RecordingFlagName}}</option>
                    </select>
                </div>
            </div>

            <!--Limit Results/Redialed Numbers-->
            <div class="d-flex mt-3">
                <div class="mr-4" style="width:200px">
                    <div class="mb-1" id="lblRecordingCount" for="txtRecordingCount" cvLocalizedText langSection="Recordings" langKey="Limit_Results">Limit Results</div>
                    <input class="form-control" style="width:50px" type="text" [(ngModel)]="recordingSettings.ResultsLimit" maxlength="3"
                           (keypress)="recordingsMainService.numberOnly($event)" (paste)="recordingsMainService.pasteNumberOnly($event)" />

                    <div class="form-check mt-4 d-flex">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="recordingSettings.IsRandomized" id="chkRandomize" />
                        <label class="form-check-label pl-1" for="chkRandomize" cvLocalizedText langSection="Recordings" langKey="Randomize">Randomize</label>
                    </div>
                </div>

                <div class="d-flex py-2 px-3" style="border:1px solid #ced4da; border-radius:4px">
                    <div class="mr-4">
                        <div cvLocalizedText langSection="Recordings" langKey="Redialed_Numbers">Redialed Numbers</div>

                        <div class="form-check mt-1">
                            <input class="form-check-input" type="radio" name="rdoSameContact" [(ngModel)]="recordingSettings.RedialRadio" id="rdoSameContactBoth" [value]="0" />
                            <label class="form-check-label pl-1 position-relative" style="left:-4px" for="rdoSameContactBoth" cvLocalizedText langSection="Recordings" langKey="BOTH">BOTH</label>
                        </div>

                        <div class="form-check mt-1">
                            <input class="form-check-input" type="radio" name="rdoSameContact" [(ngModel)]="recordingSettings.RedialRadio" id="rdoSameContactTo" [value]="1" />
                            <label class="form-check-label pl-1 position-relative" style="left:-4px" for="rdoSameContactTo" cvLocalizedText langSection="Recordings" langKey="TO">TO</label>
                        </div>

                        <div class="form-check mt-1">
                            <input class="form-check-input" type="radio" name="rdoSameContact" [(ngModel)]="recordingSettings.RedialRadio" id="rdoSameContactFrom" [value]="2" />
                            <label class="form-check-label pl-1 position-relative" style="left:-4px" for="rdoSameContactFrom" cvLocalizedText langSection="Recordings" langKey="FROM">FROM</label>
                        </div>
                    </div>

                    <div>
                        <div cvLocalizedText langSection="Recordings" langKey="Which_Occured_Than">Which Occured More Than</div>
                        <input class="form-control d-inline-block" type="text" id="recFilterContactOccurrence" placeholder="0" style="width:50px" [(ngModel)]="recordingSettings.OccurMin"
                               (keypress)="recordingsMainService.numberOnly($event)" (paste)="recordingsMainService.pasteNumberOnly($event)" />
                        <label class="ml-1" for="recFilterContactOccurrence" cvLocalizedText langSection="Recordings" langKey="Times">times</label>
                    </div>
                </div>
            </div>

            <!--Load/Add Buttons-->
            <div class="d-flex justify-content-end mt-3">
                <button type="button" class="btn btn-text btn-icon fill-cerulean addRecording mr-2" id="btnAddRecording" (click)="openManualRecordingPopup(AddManualRecordingTemplate)">
                    <svg><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
                    <span cvLocalizedText langSection="Recordings" langKey="Add_Recording">Add Recording</span>
                </button>

                <button type="button" class="btn btn-primary" (click)="loadRecordingList()" [disabled]="!validateSettings()" cvLocalizedText langSection="Recordings" langKey="Load">Load</button>
            </div>
        </div>

        <!--Loaded Recordings View-->
        <div class="content col-10 my-4 p-3" *ngIf="recordingsMainService.view == 1">
            <button type="button" class="btn btn-text-gray btn-icon mb-2 pl-0" (click)="recordingsMainService.changeView(0)">
                <svg><use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use></svg>
                <span cvLocalizedText langSection="Common" langKey="Back_Button">Back</span>
            </button>

            <div class="d-flex" style="height:calc(100vh - 176px)">
                <ag-grid-angular [gridOptions]="recordingsMainService.gridOptions" class="ag-theme-balham flex-fill" *ngIf="recordingsMainService.gridOptions"></ag-grid-angular>
            </div>
        </div>

        <!--Details View-->
        <div class="content col-6 my-4 p-3" style="min-width:686px" *ngIf="recordingsMainService.view == 2">
            <cv-recordings-details></cv-recordings-details>
        </div>

        <div class="col"></div>
    </div>
</div>
        
<ng-template #AddManualRecordingTemplate>
    <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail position-absolute" style="top:12px; right:4px; line-height:0px" (click)="closeManualRecordingPopup()">
        <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
    </button>

    <div class="font-size-20 py-3 border-bottom mb-3" cvLocalizedText langSection="Recording_Messages" langKey="Add_New_Recording">Add New Recording</div>

    <div class="color-whaleTail modal-body p-0">
        <div class="form-row">
            <div class="form-group col-md-6">
                <div>{{recordingsMainService.groupLists.Emp1Label}}</div>

                <select class="form-control" [(ngModel)]="manualRecordingSettings.EmpGroupId">
                    <option *ngFor="let group of recordingsMainService.groupLists.Emp1Groups" [label]="group.GroupName" [ngValue]="group.GroupID">{{group.GroupName}}</option>
                </select>

                <div class="d-flex align-items-center color-redRyder" *ngIf="manualRecordingSettings.EmpGroupId == 0">
                    <div><svg class="icon-12 fill-redRyder mr-1"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg></div>
                    <span cvLocalizedText langSection="Recordings" langKey="Invalid_Setting">Setting is Invalid</span>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="form-group col-md-6" style="width:30%">
                <div class="form-group">
                    <div>Rec Level</div>

                    <select class="form-control" [(ngModel)]="manualRecordingSettings.RecLevel" (ngModelChange)="updateSelectedRecGroupId()">
                        <option *ngFor="let level of recordingsMainService.groupLists.RecLevels" [label]="level.GroupTypeName" [ngValue]="level.GroupLevel">{{level.GroupTypeName}}</option>
                    </select>

                    <div class="d-flex align-items-center color-redRyder" *ngIf="manualRecordingSettings.RecLevel == 0">
                        <div><svg class="icon-12 fill-redRyder mr-1"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg></div>
                        <span cvLocalizedText langSection="Recordings" langKey="Invalid_Setting">Setting is Invalid</span>
                    </div>
                </div>
            </div>

            <div class="form-group col-md-6" style="width:60%">
                <div class="form-group">
                    <div>{{recordingsMainService.groupLists.RecLevels[manualRecordingSettings.RecLevel - 1].GroupTypeName}}</div>

                    <select class="form-control" [(ngModel)]="manualRecordingSettings.RecGroupId">
                        <option *ngFor="let group of recordingsMainService.groupLists.RecGroupsDictionary[manualRecordingSettings.RecLevel]" [label]="group.GroupName" [ngValue]="group.GroupID">{{group.GroupName}}</option>
                    </select>

                    <div class="d-flex align-items-center color-redRyder" *ngIf="manualRecordingSettings.RecGroupId == 0">
                        <div><svg class="icon-12 fill-redRyder mr-1"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg></div>
                        <span cvLocalizedText langSection="Recordings" langKey="Invalid_Setting">Setting is Invalid</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="form-group col-md-4">
                <label class="mb-1" cvLocalizedText langSection="Recordings" langKey="Call_Date">Contact Date</label>

                <div class="input-group position-static">
                    <cv-baremetrics-calendar class="d-block daterange daterange--single" [(currentDate)]="manualRecordingSettings.ContactDate" placeholder="00/00/0000"></cv-baremetrics-calendar>

                    <cv-time-picker class="mt-1" [(ngModel)]="manualRecordingSettings.ContactDate"></cv-time-picker>
                </div>
            </div>

            <div class="form-group col-md-4">
                <div class="mb-1" cvLocalizedText langSection="Recordings" langKey="Contact_ID">Contact ID</div>
                <input class="form-control" type="text" [(ngModel)]="manualRecordingSettings.ContactId" />

                <div class="d-flex align-items-center color-redRyder" *ngIf="manualRecordingSettings.ContactId == '' || !valueWithinBigIntRange(manualRecordingSettings.ContactId)">
                    <div><svg class="icon-12 fill-redRyder mr-1"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg></div>
                    <span cvLocalizedText langSection="Recordings" langKey="Invalid_Setting">Setting is Invalid</span>
                </div>
            </div>

            <div class="form-group col-md-4">
                <label class="mb-1" cvLocalizedText langSection="Recordings" langKey="Phone_Number">Phone Number</label>
                <input class="form-control" type="text" [(ngModel)]="manualRecordingSettings.Phone" (keypress)="recordingsMainService.numberOnly($event)" (paste)="recordingsMainService.pasteNumberOnly($event)" />
            </div>
        </div>

        <div class="form-row">
            <div class="form-group col-md-5">
                <label class="mb-1" cvLocalizedText langSection="Recordings" langKey="Disposition">Disposition</label>
                <input class="form-control" type="text" [(ngModel)]="manualRecordingSettings.Disposition" />
            </div>

            <div class="form-group col-md-4">
                <label class="mb-1" cvLocalizedText langSection="Recordings" langKey="Other_ID">Other ID</label>
                <input class="form-control" type="text" [(ngModel)]="manualRecordingSettings.OtherId" (keypress)="recordingsMainService.numberOnly($event)" (paste)="recordingsMainService.pasteNumberOnly($event)" />
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12">
                <label class="mb-1" cvLocalizedText langSection="Recordings" langKey="Notes">Notes</label>
                <input class="form-control" type="text" [(ngModel)]="manualRecordingSettings.Notes" />
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="cancelAddRecording btn btn-text" (click)="closeManualRecordingPopup()" cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</button>
        <button type="button" class="saveAddRecording btn btn-primary" (click)="saveManualRecording()" cvLocalizedText langSection="Common" langKey="Add">Add</button>
    </div>
</ng-template>
